module.exports = __webpack_public_path__ + "img/9.8119712c.jpg";